import actions from './actions';
import reducer from './reducer.js';

const subscribe = {
    actions,
    reducer
};

export default subscribe;
